export function getDateString(date: Date): string {
	if (!date) return '';

	const yyyy = date.getFullYear();
	let mm: any = date.getMonth() + 1;
	let dd: any = date.getDate();

	if (dd < 10) dd = '0' + dd;
	if (mm < 10) mm = '0' + mm;

	return yyyy + mm + dd;
}

export function getDateFormatted(date: Date): string {
	const yyyy = date.getFullYear();
	let mm: any = date.getMonth() + 1;
	let dd: any = date.getDate();

	if (dd < 10) dd = '0' + dd;
	if (mm < 10) mm = '0' + mm;

	return dd + '/' + mm + '/' + yyyy;
}
